"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeKeytoAmountType = exports.storeKeyToLocale = exports.toStoreKey = exports.toStore = exports.toStoreId = void 0;
const toStoreId = (storeOrStoreId) => {
    switch (typeof storeOrStoreId === "string" &&
        storeOrStoreId.toLocaleLowerCase()) {
        case "10151":
        case "en-gb":
        case "gb":
        case "uk":
        case "uk-store":
            return "10151";
        case "10152":
        case "en-us":
        case "us":
        case "us-store":
            return "10152";
        default:
            throw new Error(`Cannot convert toStoreId, invalid input: ${storeOrStoreId}`);
    }
};
exports.toStoreId = toStoreId;
const toStore = (storeOrStoreId) => {
    switch (typeof storeOrStoreId === "string" &&
        storeOrStoreId.toLocaleLowerCase()) {
        case "10151":
        case "en-gb":
        case "gb":
        case "uk":
        case "uk-store":
            return "uk";
        case "10152":
        case "en-us":
        case "us":
        case "us-store":
            return "us";
        default:
            throw new Error(`Cannot convert toStore, invalid input: ${storeOrStoreId}`);
    }
};
exports.toStore = toStore;
const toStoreKey = (storeOrStoreId) => {
    switch (typeof storeOrStoreId === "string" &&
        storeOrStoreId.toLocaleLowerCase()) {
        case "10151":
        case "en-gb":
        case "gb":
        case "uk":
        case "uk-store":
            return "uk-store";
        case "10152":
        case "en-us":
        case "us":
        case "us-store":
            return "us-store";
        default:
            throw new Error(`Cannot convert toStoreKey, invalid input: ${storeOrStoreId}`);
    }
};
exports.toStoreKey = toStoreKey;
const storeKeyToLocale = (storeOrStoreId) => {
    switch (typeof storeOrStoreId === "string" &&
        storeOrStoreId.toLocaleLowerCase()) {
        case "10151":
        case "gb":
        case "en-gb":
        case "uk":
        case "uk-store":
            return "en-GB";
        case "10152":
        case "en-us":
        case "us":
        case "us-store":
            return "en-US";
        default:
            throw new Error(`Cannot convert to Locale, invalid input: ${storeOrStoreId}`);
    }
};
exports.storeKeyToLocale = storeKeyToLocale;
const storeKeytoAmountType = (storeOrStoreId) => {
    switch (typeof storeOrStoreId === "string" &&
        storeOrStoreId.toLocaleLowerCase()) {
        case "10151":
        case "gb":
        case "en-gb":
        case "uk":
        case "uk-store":
            return "gross";
        case "10152":
        case "en-us":
        case "us":
        case "us-store":
            return "net";
        default:
            throw new Error(`Cannot convert to AmountType, invalid input: ${storeOrStoreId}`);
    }
};
exports.storeKeytoAmountType = storeKeytoAmountType;
//# sourceMappingURL=store.js.map